/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {useSelector} from 'react-redux';
import {MutableList} from './MutableList';
import {RevokeUserAPIKeyButton} from "./Buttons/RevokeUserAPIKeyButton";
import {AddUserAPIKeyButton} from "./Buttons/AddUserAPIKeyButton";

/**
 * Custom list component for the UserAPIKeys association on the User model.
 * Wraps MutableList with a custom RevokeButton and a Generate API Key modal.
 *
 * View mode: read-only list of keys via MutableList (empty state handled by StreamBankListEmptyRow).
 * Edit mode: adds "Generate API Key..." button and per-key Revoke buttons.
 *
 * Generate and revoke are handled directly via UserAPIKeyService rather than the
 * normal form save flow. AddItem/RemoveItem from ChildrenFieldEditor are used only
 * to keep local list state in sync; UserAPIKeys is not included in withAssociations
 * on the User PUT, so the form save never touches these records.
 */
export const UserAPIKeyMutableList = (props) => {
    const {
        RootData,
    } = props;

    const currentUser = useSelector(state => state.userState.user);
    const isOwnProfile = RootData?.userId && currentUser?.userId &&
        Number(RootData.userId) === Number(currentUser.userId);

    if (!isOwnProfile) {
        return null;
    }

    return (
        <MutableList
            {...props}
            AddItemButton={AddUserAPIKeyButton}
            RemoveItemButton={RevokeUserAPIKeyButton}
        />
    );
};
